import { withInstall } from '@code-monkey-ui/utils'

import Col from './src/col.vue'

export const ElCol = withInstall(Col)
export default ElCol

export * from './src/col'
